import { Timezone } from 'trading-view';

export const getUtcOffset = () => {
  return -(new Date().getTimezoneOffset() / 60);
};

/**
 * Gets the user's timezone for TradingView charts
 */
export const getChartTimezone = (): Timezone => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return tz as Timezone;
};
